const DevicesListStatus = {
  isDEFAULT: false,
  isANDROID: false,
  isLG: false,
  isSAMSUNG: false,
  isTIZEN: false,
  isTIZEN_TEP: false,
  isPHILIPS: false,
  isDUNEHD: false,
  isVIERA: false,
  isAlliance: false,
  isPlaystation: false,
  isWEBOS: false,
  isARRIS: false,
  isHISENSE: false,
};

const obj = { DevicesListStatus };

export default obj;
